import BasePeripheral from '@appblocks/codegeneration/Peripherals/_BasePeripheral';
import {
    SettingType, Setting, BlockType, ValidationMessage, ValidationMessageType,
    TibboDataType,
    SettingControlType,
    CodeBlock,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import Peripherals from '@appblocks/codegeneration/Peripherals';
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import * as micropython from './micropython';
import * as zephyr from './zephyr';
import * as simulator from './simulator';

const LCD_SCREEN_WIDGET_COLUMNS = 128;
const LCD_SCREEN_WIDGET_ROWS = 64;

export default class SSD1306 extends BasePeripheral {
    constructor() {
        super();
        this.id = 'ssd1306';
        this.name = 'SSD1306 OLED display';

        this.requirements = [['zephyr', 'micropython']];

        const settings: Array<Setting> = [
            {
                id: 'GENERAL',
                name: 'General',
                settingType: SettingType.GROUP,
                default: '',
            },
            {
                id: 'IMAGES_GROUP',
                name: 'Images',
                settingType: SettingType.GROUP,
                default: '',
            },
            {
                id: 'I2C',
                name: 'I2C Peripheral',
                settingType: SettingType.OPTION,
                refId: 'i2c',
                group: 'GENERAL',
                default: '',
            },
            // {
            //     id: 'VCC',
            //     name: 'VCC',
            //     settingType: SettingType.PIN,
            //     required: true,
            //     meta: '3V3',
            //     default: '',
            // },
            // {
            //     id: 'GND',
            //     name: 'GND',
            //     settingType: SettingType.PIN,
            //     meta: 'GND',
            //     required: true,
            //     default: '',
            // },
            // {
            //     id: 'SDA',
            //     name: 'SDA',
            //     settingType: SettingType.PIN,
            //     meta: 'GPIO',
            //     required: true,
            //     default: '',
            //     group: 'GENERAL',
            // },
            // {
            //     id: 'SCL',
            //     name: 'SCL',
            //     settingType: SettingType.PIN,
            //     meta: 'GPIO',
            //     required: true,
            //     default: '',
            //     group: 'GENERAL',
            // },
            {
                id: 'WIDGETS',
                name: 'LCD Widgets',
                settingType: SettingType.HIDDEN,
                required: true,
                group: 'GENERAL',
                controlType: SettingControlType.WIDGETS,
                default: new Array<BaseFeature>(0),
            },
            {
                id: 'SCREENS',
                name: 'Screens',
                settingType: SettingType.ARRAY,
                required: true,
                group: 'GENERAL',
                refId: 'display_screen',
                default: new Array<BaseFeature>(0),
            },
            {
                id: 'IMAGES',
                name: 'Images',
                settingType: SettingType.ARRAY,
                refId: 'lcd_image',
                required: true,
                group: 'IMAGES_GROUP',
                default: new Array<BaseFeature>(0),
            },
            {
                id: 'LCD_SCREEN_WIDGET_COLUMNS',
                name: 'Width',
                settingType: SettingType.NUMBER,
                required: true,
                default: LCD_SCREEN_WIDGET_COLUMNS.toString(),
            },
            {
                id: 'LCD_SCREEN_WIDGET_ROWS',
                name: 'Height',
                settingType: SettingType.NUMBER,
                required: true,
                default: LCD_SCREEN_WIDGET_ROWS.toString(),
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getFiles(): Array<string> {
        if (this.project.runtime === 'micropython') {
            return micropython.getFiles(this);
        }
        return super.getFiles();
    }

    getDependencies(): string[] {
        return [
            'display_lib',
        ];
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'simulator':
                return simulator.getCodeBlocks(this);
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            default:
                return [];
        }
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/taiko/ssi_i2c';
    }
}
